import { render, staticRenderFns } from "./yishengpaiban.vue?vue&type=template&id=ed8ddc60&scoped=true"
import script from "./yishengpaiban.vue?vue&type=script&lang=js"
export * from "./yishengpaiban.vue?vue&type=script&lang=js"
import style0 from "./yishengpaiban.vue?vue&type=style&index=0&id=ed8ddc60&prod&scoped=true&lang=less"
import style1 from "./yishengpaiban.vue?vue&type=style&index=1&id=ed8ddc60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8ddc60",
  null
  
)

export default component.exports